import { useState, useEffect } from 'react';
import Table from '../components/Groups/Table';
import Content from '../components/Content';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../components/Jobs/Jobs.css';
import { Link } from 'react-router-dom';

import Skeleton from '../components/ui/Skeleton/Skeleton';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchGroups } from '../utils/api';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { UserInfoType } from '../types/AppTypes';

const Groups = (): JSX.Element => {
  const { groups, loading, message, error } = useAppSelector((state) => state.groups);
  const [skeletonColumns] = useState(['Group ID', 'Podcasts', 'Permissions']);
  const [skeletonRows] = useState([1, 2, 3]);

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchGroups(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="error">
        <span>{message}</span>
      </div>
    );
  }

  const permissions = userInfo?.permissions;

  const groupsWithoutAll = groups.filter(group=>{
    return group.groupId!=='ALL_PERMISSIONS_GROUP'
  })

  return (
    <>
      {(permissions?.includes('groups.create') || userInfo?.isAdmin )&& (
        <Link to="/group/add">
          <button
            type="button"
            className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
          >
            Add
          </button>
        </Link>
      )}
      <Content loading={false}>
        {loading ? <Skeleton columns={skeletonColumns} rows={skeletonRows} /> : <Table groups={groupsWithoutAll} />}
      </Content>
    </>
  );
};

export default Groups;
